import { ProfileFiveTwoNineAccountFragmentFragment } from "@/generated/graphql"
import { cn } from "@/lib/utils"
import ChevronRight from "@/novus/assets/images/chevron-right.svg"
import { Avatar } from "@/novus/components/avatar"
import { editBeneficiaryPath } from "@/novus/novus-paths"
import React from "react"
import { Link } from "react-router-dom"

const FiveTwoNineAccountsListItem = ({
  fiveTwoNineAccount,
}: { fiveTwoNineAccount: ProfileFiveTwoNineAccountFragmentFragment }) => {
  const accountNumber = fiveTwoNineAccount.accountNumber
    ?.replace(/\s/g, "")
    ?.match(/.{1,4}/g)
    ?.join(" ")

  return (
    <Link
      to={editBeneficiaryPath({ id: fiveTwoNineAccount.id })}
      className={cn(
        "shadow-custom-md px-4 py-3 flex flex-row items-center gap-4 border border-neutral-200 rounded-md",
        "hover:bg-neutral-50",
        "md:py-4 md:px-6",
      )}
      data-test="five-two-nine-account-list-item"
    >
      <div className="flex items-center gap-4 flex-1">
        <Avatar
          viewer={{
            photoUrl: fiveTwoNineAccount.beneficiaryPhotoUrl,
            firstName: fiveTwoNineAccount.beneficiaryFirstName,
            lastName: fiveTwoNineAccount.beneficiaryLastName,
          }}
          size="md"
        />
        <div
          className={cn(
            "flex flex-1 flex-col gap-2",
            "md:justify-between md:flex-row md:gap-4",
          )}
        >
          <div>
            <div className="text-lg text-textPrimary line-clamp-2">
              {fiveTwoNineAccount.beneficiaryFirstName}{" "}
              {fiveTwoNineAccount.beneficiaryLastName}
            </div>
            <div className="text-sm text-neutral-500 line-clamp-2">
              {fiveTwoNineAccount.program?.name} -{" "}
              {fiveTwoNineAccount.program?.sponsorState?.abbreviation}
            </div>
          </div>
          <div className={cn("flex items-center gap-8", "md:justify-end")}>
            <div
              className={cn("font-mono text-sm line-clamp-1", "md:text-lg")}
              title={accountNumber}
            >
              {accountNumber}
            </div>
          </div>
        </div>
      </div>
      <div className="ml-4">
        <img src={ChevronRight} alt="View" />
      </div>
    </Link>
  )
}

export default FiveTwoNineAccountsListItem
